import { useRef, useState } from 'react'
import ImageInput from '../../../core/components/UI/ImageInput'
import SelectMineralTypes from '../../../core/components/UI/SelectMineralTypes'
import RichTextEditor from '../../../core/components/UI/RichTextEditor'
import { FaSpinner } from 'react-icons/fa'
import useMineralsActions from '../../hooks/useMineralsActions'
import { useNavigate } from 'react-router-dom'
import { toastSuccess } from '../../../helper'
export default function FormCreateMineral() {
  const navigate = useNavigate()

  const { createMineral, inProgress } = useMineralsActions()
  const [mineralImage, setMineralImage] = useState(null)
  const [mineralType, setMineralType] = useState(null)
  const mineralSymbolRef = useRef(null)
  const mineralNameAr = useRef(null)
  const mineralNameEn = useRef(null)
  const mineralStudiesLinkRef = useRef(null)
  const mineralDescriptionArRef = useRef(null)
  const mineralDescriptionEnRef = useRef(null)
  const mineralHistoryArRef = useRef(null)
  const mineralHistoryEnRef = useRef(null)
  const [mineralSourceImage, setMineralSourceImage] = useState(null)
  const mineralSourceArRef = useRef(null)
  const mineralSourceEnRef = useRef(null)
  const mineralCompoundArRef = useRef(null)
  const mineralCompoundEnRef = useRef(null)

  async function handleOnSubmitCreateMineralForm(event) {
    event.preventDefault()
    const payload = {
      name_ar: mineralNameAr.current.value,
      name_en: mineralNameEn.current.value,
      symbol: mineralSymbolRef.current.value,
      category_id: mineralType,
      image: mineralImage,
      studies_link: mineralStudiesLinkRef.current.value,
      description_ar: mineralDescriptionArRef.current.getContent(),
      description_en: mineralDescriptionEnRef.current.getContent(),
      history_description_ar: mineralHistoryArRef.current.getContent(),
      history_description_en: mineralHistoryEnRef.current.getContent(),
      source_image: mineralSourceImage,
      source_description_ar: mineralSourceArRef.current.getContent(),
      source_description_en: mineralSourceEnRef.current.getContent(),
      compound_description_ar: mineralCompoundArRef.current.getContent(),
      compound_description_en: mineralCompoundEnRef.current.getContent(),
    }

    const message = await createMineral(payload)
    if (message) {
      toastSuccess(message)
      navigate(`/minerals`)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateMineralForm}
      className="flex flex-col gap-4"
    >
      <div className="flex flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_IMAGE"
        >
          صورة المعدن <span className="text-danger-600">*</span>
        </label>
        <ImageInput
          id={'ID_MINERAL_IMAGE'}
          onChange={(image) => setMineralImage(image)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_TYPE"
        >
          نوع معدن <span className="text-danger-600">*</span>
        </label>
        <SelectMineralTypes onChange={(value) => setMineralType(value)} />
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_SYMBOL"
          >
            رمز معدن
          </label>
          <input
            id="ID_MINERAL_SYMBOL"
            type="text"
            ref={mineralSymbolRef}
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_NAME_AR"
          >
            اسم معدن بالعربية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_MINERAL_NAME_AR"
            ref={mineralNameAr}
            type="text"
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_NAME_EN"
          >
            اسم معدن بالإنجليزية <span className="text-danger-600">*</span>
            <em className="font-normal text-accent-600">
              {' '}
              (المرجو عدم إدخال اسم المعدن بالعربية هنا)
            </em>
          </label>
          <input
            id="ID_MINERAL_NAME_EN"
            ref={mineralNameEn}
            type="text"
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="line-clamp-1 font-bold"
          htmlFor="ID_MINERAL_STUDES_URL"
        >
          رابط الدراسات
        </label>
        <input
          dir="ltr"
          id="ID_MINERAL_STUDES_LINK"
          ref={mineralStudiesLinkRef}
          type="url"
          placeholder="https://...."
          className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_DESCRIPTION_AR"
        >
          وصف المعدن بالعربية <span className="text-danger-600">*</span>
        </label>
        <RichTextEditor
          onInit={(event, editor) => (mineralDescriptionArRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_DESCRIPTION_EN"
        >
          وصف المعدن بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) => (mineralDescriptionEnRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_AR"
        >
          تاريخ المعدن بالعربية <span className="text-danger-600">*</span>
        </label>
        <RichTextEditor
          onInit={(event, editor) => (mineralHistoryArRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_EN"
        >
          تاريخ المعدن بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) => (mineralHistoryEnRef.current = editor)}
        />
      </div>
      <div className="flex flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_IMAGE"
        >
          صورة مصدر المعدن <span className="text-danger-600">*</span>
        </label>
        <ImageInput
          id={'ID_MINERAL_SOURCE_IMAGE'}
          onChange={(image) => setMineralSourceImage(image)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_AR"
        >
          مصدر المعدن بالعربية <span className="text-danger-600">*</span>
        </label>
        <RichTextEditor
          onInit={(event, editor) => (mineralSourceArRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_EN"
        >
          مصدر المعدن بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) => (mineralSourceEnRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COMPOUND_AR"
        >
          مركبات المعدن بالعربية
        </label>
        <RichTextEditor
          onInit={(event, editor) => (mineralCompoundArRef.current = editor)}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COMPOUND_EN"
        >
          مركبات المعدن بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) => (mineralCompoundEnRef.current = editor)}
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري إنشاء معدن...</span>
          </>
        ) : (
          <span>إنشاء معدن</span>
        )}
      </button>
    </form>
  )
}
